// extracted by mini-css-extract-plugin
export default {"root":"WbCKm__root","tabPanel":"NsCIr__tabPanel","dataGrid":"IJoZ9__dataGrid","categoryContainer":"dNfNw__categoryContainer"};